import { render, staticRenderFns } from "./TutorProfile.vue?vue&type=template&id=40306417&scoped=true"
import script from "./TutorProfile.vue?vue&type=script&lang=js"
export * from "./TutorProfile.vue?vue&type=script&lang=js"
import style0 from "./TutorProfile.vue?vue&type=style&index=0&id=40306417&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40306417",
  null
  
)

export default component.exports